module.exports = "h2{\r\ntext-align: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/about/about.component.css
// module id = ./src/app/home/about/about.component.css
// module chunks = main